export default __webpack_public_path__ + "static/media/gallery_01.52d480f0.jpg";